import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { SdvorSharedCmsComponents } from '../cms-components.enum';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        ButtonModule: {
          module: () => import('./button.module').then((m) => m.ButtonModule),
          cmsComponents: [SdvorSharedCmsComponents.RosaButtonComponent],
        },
      },
    }),
  ],
})
export class ButtonLazyModule {}
